import { GetterTree } from 'vuex'
import { SearchState } from './state'
import { RootState } from '@/store'

export const Keys = {
  GET_SEARCH_CONDITIONS: 'search/conditions',
  GET_SEARCH_ACTIVITY_LIST: 'search/activity_list',
  GET_SEARCH_AREA_LIST: 'search/area_list',
  IS_MASTER_FETCHING: 'search/master_fetching',
  IS_MASTER_FETCHED: 'search/master_fetched',
}

export const getters: GetterTree<SearchState, RootState> = {
  [Keys.GET_SEARCH_CONDITIONS]: (state) => state.conditions,
  [Keys.GET_SEARCH_ACTIVITY_LIST]: (state) => state.activities,
  [Keys.GET_SEARCH_AREA_LIST]: (state) => state.areasByPref,
  [Keys.IS_MASTER_FETCHING]: (state) => state.isMasterFetching,
  [Keys.IS_MASTER_FETCHED]: (state) => state.isMasterFetched,
}
